const getZustandStoreBroadcastChannelName = storeName => {
	const searchParams = new URLSearchParams(window.location.search);
	const StudyInstanceUIDs = searchParams.get('StudyInstanceUIDs');
	const internalManagingOrganizationID = searchParams.get('internalManagingOrganizationID');

	return `ZustandSync|ImageViewer|${StudyInstanceUIDs}|${internalManagingOrganizationID}|${storeName}`;
};

export { getZustandStoreBroadcastChannelName };
